import { combineReducers } from "redux";
import { withResetState } from "../../../wrapperReducer";
import commonReducer from "../../commonReducer/commonReducer";
import drivingMarketParamsReducer, { initPriceState } from "../common/params";
import priceBuzzer from "./priceBuzzer";
export default combineReducers({
    reducersData: priceBuzzer,
    commonData: commonReducer,
    paramsData: withResetState(initPriceState)(drivingMarketParamsReducer),
});
